<div class="p-4 flex flex-col gap-8">

  <!-- Basic Buttons -->
  <section class="preview-section">
    <h2 class="section-title">Basic</h2>
    <div class="button-row">
      @for (severity of severities; track severity.name) {
        @if (severity.value) {
          <p-button [label]="severity.name" [severity]="severity.value"></p-button>
        } @else {
          <p-button label="Primary"></p-button>
        }
      }
    </div>
  </section>

  <!-- Rounded Buttons -->
  <section class="preview-section">
    <h2 class="section-title">Rounded Button</h2>
    <div class="button-row">
      @for (severity of severities; track severity.name) {
        @if (severity.value) {
          <p-button [label]="severity.name" [severity]="severity.value" [rounded]="true"></p-button>
        } @else {
          <p-button label="Primary" [rounded]="true"></p-button>
        }
      }
    </div>
  </section>

  <!-- Text Buttons -->
  <section class="preview-section">
    <h2 class="section-title">Text Button</h2>
    <div class="button-row">
      @for (severity of severities; track severity.name) {
        @if (severity.value) {
          <p-button [label]="severity.name" [severity]="severity.value" [text]="true"></p-button>
        } @else {
          <p-button label="Primary" [text]="true"></p-button>
        }
      }
    </div>
  </section>

  <!-- Outlined Buttons -->
  <section class="preview-section">
    <h2 class="section-title">Outlined Button</h2>
    <div class="button-row">
      @for (severity of severities; track severity.name) {
        @if (severity.value) {
          <p-button [label]="severity.name" [severity]="severity.value" [outlined]="true"></p-button>
        } @else {
          <p-button label="Primary" [outlined]="true"></p-button>
        }
      }
    </div>
  </section>

  <!-- Rounded Outline Buttons -->
  <section class="preview-section">
    <h2 class="section-title">Rounded Outline</h2>
    <div class="button-row">
      @for (severity of severities; track severity.name) {
        @if (severity.value) {
          <p-button [label]="severity.name" [severity]="severity.value" [outlined]="true" [rounded]="true"></p-button>
        } @else {
          <p-button label="Primary" [outlined]="true" [rounded]="true"></p-button>
        }
      }
    </div>
  </section>

  <hr class="my-4 border-gray-300">

  <h2 class="text-2xl font-bold">Icon Only Buttons</h2>

  <!-- Icon Only - Basic -->
  <section class="preview-section">
    <h2 class="section-title">Basic</h2>
    <div class="button-row">
      @for (severity of severities; track severity.name) {
        @if (severity.value) {
          <p-button [icon]="iconMap[severity.name]" [severity]="severity.value"></p-button>
        } @else {
          <p-button [icon]="iconMap[severity.name]"></p-button>
        }
      }
    </div>
    <h3 class="section-title">fa icons</h3>
    <div class="button-row">
      <button class="p-button p-button-icon-only">
        <i class="fa-regular fa-check"></i>
      </button>
      <button class="p-button p-button-icon-only p-button-secondary">
        <i class="fa-regular fa-floppy-disk"></i>
      </button>
      <button class="p-button p-button-icon-only p-button-success">
        <i class="fa-regular fa-floppy-disk"></i>
      </button>
      <button class="p-button p-button-icon-only p-button-info">
        <i class="fa-regular fa-floppy-disk"></i>
      </button>
      <button class="p-button p-button-icon-only p-button-warn">
        <i class="fa-regular fa-floppy-disk"></i>
      </button>
      <button class="p-button p-button-icon-only p-button-help">
        <i class="fa-regular fa-floppy-disk"></i>
      </button>
      <button class="p-button p-button-icon-only p-button-danger">
        <i class="fa-regular fa-floppy-disk"></i>
      </button>
      <button class="p-button p-button-icon-only p-button-contrast">
        <i class="fa-regular fa-floppy-disk"></i>
      </button>
    </div>
  </section>

  <!-- Icon Only - Rounded -->
  <section class="preview-section">
    <h2 class="section-title">Rounded Button</h2>
    <div class="button-row">
      @for (severity of severities; track severity.name) {
        @if (severity.value) {
          <p-button [icon]="iconMap[severity.name]" [severity]="severity.value" [rounded]="true"></p-button>
        } @else {
          <p-button [icon]="iconMap[severity.name]" [rounded]="true"></p-button>
        }
      }
    </div>
    <h3 class="section-title">fa icons</h3>
    <div class="button-row">
      <button class="p-button p-button-icon-only p-button-rounded">
        <i class="fa-regular fa-floppy-disk"></i>
      </button>
    </div>
  </section>

  <!-- Icon Only - Text -->
  <section class="preview-section">
    <h2 class="section-title">Text Button</h2>
    <div class="button-row">
      @for (severity of severities; track severity.name) {
        @if (severity.value) {
          <p-button [icon]="iconMap[severity.name]" [severity]="severity.value" [text]="true"></p-button>
        } @else {
          <p-button [icon]="iconMap[severity.name]" [text]="true"></p-button>
        }
      }
    </div>
    <h3 class="section-title">fa icons</h3>
    <div class="button-row">
      <button class="p-button p-button-icon-only p-button-text">
        <i class="fa-regular fa-floppy-disk"></i>
      </button>
    </div>
  </section>

  <!-- Icon Only - Outlined -->
  <section class="preview-section">
    <h2 class="section-title">Outlined Button</h2>
    <div class="button-row">
      @for (severity of severities; track severity.name) {
        @if (severity.value) {
          <p-button [icon]="iconMap[severity.name]" [severity]="severity.value" [outlined]="true"></p-button>
        } @else {
          <p-button [icon]="iconMap[severity.name]" [outlined]="true"></p-button>
        }
      }
    </div>
    <h3 class="section-title">fa icons</h3>
    <div class="button-row">
      <button class="p-button p-button-icon-only p-button-outlined">
        <i class="fa-regular fa-floppy-disk"></i>
      </button>
    </div>
  </section>

  <!-- Icon Only - Rounded Outline -->
  <section class="preview-section">
    <h2 class="section-title">Rounded Outline</h2>
    <div class="button-row">
      @for (severity of severities; track severity.name) {
        @if (severity.value) {
          <p-button [icon]="iconMap[severity.name]" [severity]="severity.value" [outlined]="true" [rounded]="true"></p-button>
        } @else {
          <p-button [icon]="iconMap[severity.name]" [outlined]="true" [rounded]="true"></p-button>
        }
      }
    </div>
    <h3 class="section-title">fa icons</h3>
    <div class="button-row">
      <button class="p-button p-button-icon-only p-button-outlined p-button-rounded">
        <i class="fa-regular fa-floppy-disk"></i>
      </button>
    </div>
  </section>

  <hr class="my-4 border-gray-300">

  <h2 class="text-2xl font-bold">Button Sizes</h2>

  <!-- Button Sizes -->
  <section class="preview-section">
    <h2 class="section-title">Small, Default, Large</h2>
    <p-card>
      <div class="button-row">
        <p-button label="Button" size="small"></p-button>
        <p-button label="Button"></p-button>
        <p-button label="Button" size="large"></p-button>
      </div>
    </p-card>
  </section>

<!--  Card view-->

  <hr class="my-4 border-gray-300">

  <h2 class="text-2xl font-bold">Card view</h2>

  <p-card>
    <div class="flex gap-2">
      <div class="flex flex-col w-64 bg-surface-0 p-6 gap-6 rounded-l-2xl shadow-[0px_1px_2px_-1px_rgba(0,0,0,0.10),0px_1px_3px_0px_rgba(0,0,0,0.10)]">
        Title card
      </div>
      <div class="flex-1 bg-surface-50 p-6 rounded-r-2xl shadow-[0px_1px_2px_-1px_rgba(0,0,0,0.10),0px_1px_3px_0px_rgba(0,0,0,0.10)]">
        Content card
      </div>
    </div>
  </p-card>

</div>
